import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'

import { useApi } from '@tabeeb/modules/shared/utils/API/hooks'

import { QualificationsQueryKeys } from '../queries'

const useQualificationVersionsSearch = (search: string) => {
  const { certificateServiceApi } = useApi()

  const query = useQuery({
    queryKey: [QualificationsQueryKeys.QualificationVersionsSearch, search],
    queryFn: () => certificateServiceApi.qualificationVersions.getSearchedAsync({ search }),
  })

  return useMemo(() => ({ loading: query.isLoading, qualifications: query.data ?? [] }), [query.data, query.isLoading])
}

export default useQualificationVersionsSearch
